const IconCalculationArea = ({ style }) => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M6.33333 9V10.7778M3.66667 9V11.6667M9 9V11.6667M14.3333 9V11.6667M11.6667 9V10.7778M1 1V4.55556M1 2.77778H17M17 1V4.55556M16 9C16.552 9 17 9.45511 17 10.016V15.0951C17 15.656 16.552 16.1111 16 16.1111H1.88889C1.65314 16.1111 1.42705 16.0175 1.26035 15.8508C1.09365 15.6841 1 15.458 1 15.2222V10.016C1 9.45511 1.448 9 2 9H16Z"
        stroke="#252525"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
  
export default IconCalculationArea
  